module.exports = __webpack_public_path__ + "img/1552660655.862957e8.jpg";